<template>
    <div class="admin_set">
        <content-header>
            <content-header-title slot="header-left">
                <span>{{$t('adminSet.CSSZ')}}</span>
            </content-header-title>
            <div class="hrader-right" slot="header-right">
                <span class="form-name">{{$t('adminSet.MFRSSX')}}</span>
                <el-input
                    style="width: 160px"
                    v-model.number="freeData.freeMaxPerson" 
                    size="mini"
                    @keyup.enter.native="()=>{blurInput('free')}"
                    @blur="()=>{blurInput('free')}"
                    maxlength="10"
                >
                    <span slot="suffix" class="input-text">{{$t('adminSet.RC')}}</span>
                </el-input>
                <span class="form-name">{{$t('adminSet.MFCSHJG')}}</span>
                <el-input
                    style="width: 160px"
                    @keyup.enter.native="()=>{blurInput('free')}"
                    @blur="()=>{blurInput('free')}"
                    v-model.number="freeData.freeInitInterval"
                    size="mini"
                    maxlength="10"
                >
                    <span slot="suffix" class="input-text">{{$t('adminSet.FZ')}}</span>
                </el-input>
            </div>
        </content-header>
        <div class="seach-set-box">
            <el-input 
                v-model="searchContent" 
                @keyup.enter.native="getList"
                class="seach-input"
                :placeholder="$t('adminSet.QSRJGMCHJGID')"
                size="small">
                <span slot="suffix" @click="getList" class="el-icon-search input-seach"></span>
            </el-input>
            <div class="set-box">
                <span class="form-name">{{$t('adminSet.CPCSHJG')}}</span>
                <el-input
                    style="width: 160px"
                    @keyup.enter.native="()=>{blurInput('pro')}"
                    @blur="()=>{blurInput('pro')}"
                    v-model.number="proData.proInitInterval"
                    size="mini"
                    maxlength="10"
                >
                    <span slot="suffix" class="input-text">{{$t('adminSet.FZ')}}</span>
                </el-input>
                <span class="form-name">{{$t('adminSet.CPXHSX')}}</span>
                <el-input
                    style="width: 160px; margin-right: 18px"
                    v-model="proData.proLoopTimes"
                    @keyup.enter.native="()=>{blurInput('pro')}"
                    @blur="()=>{blurInput('pro')}"
                    size="mini"
                >
                    <span slot="suffix" class="input-text">{{$t('adminSet.C')}}</span>
                </el-input>
                <el-button 
                    type="primary"
                    @click="()=>{resetPro('proInitInterval')}"
                    size="mini"> 
                    {{$t('adminSet.CZCSHJG')}}
                </el-button>
                <el-button 
                    type="primary"
                    @click="()=>{resetPro('proLoopTimes')}"
                    size="mini"> 
                    {{$t('adminSet.CZXHSX')}}
                </el-button>
            </div>
        </div>
        <div class="main" v-loading="loading">
            <c-table
                @operation="operation" 
                :tableData="orgList" 
                :ISChangeCheckout="false" 
                :tableHeader="teamTableHeader" 
                :TableHeight="`calc( 100vh - ${ total > 100 ? 262 : 224}px )`">
            </c-table>
            <paging 
                :total="total" 
                @currentChange="(pageNo)=>{this.pageNo = pageNo; getList('pageNo')}" 
                :pageNo="pageNo">
            </paging>
        </div>
        <dialog-lx v-bind.sync="dialogData" @saveClick="saveOrgRule">
            <div class="content-main">
                <span class="form-name">{{$t('adminSet.CPCSHJG')}}</span>
                <el-input
                    style="width: 160px"
                    v-model.number="orgRuleData.proInitInterval"
                    size="mini"
                    maxlength="10"
                >
                    <span slot="suffix" class="input-text">{{$t('adminSet.FZ')}}</span>
                </el-input>
                <p>
                    <span class="form-name">{{$t('adminSet.CPXHSX')}}&nbsp;&nbsp;&nbsp;</span>
                    <el-input
                        style="width: 160px; margin-right: 18px"
                        v-model="orgRuleData.proLoopTimes"
                        size="mini"
                    >
                        <span slot="suffix" class="input-text">{{$t('adminSet.C')}}</span>
                    </el-input>
                </p>
                
            </div>
        </dialog-lx>
    </div>
</template>
<script>
import mins from './mins'
import CTable from '@/components/table'
import dialogLx from '@/components/dialog-lx'
import paging from '@/components/paging'
export default {
    name: 'adminSet',
    mixins: [mins],
    components:{CTable, dialogLx, paging},
}
</script>
<style scoped lang="scss">
.admin_set{
    height: 100%;
    width: 100%;
    .main{
        // padding: 8px 10px;
        box-sizing: border-box;
        margin: 8px 23px 0 12px;
    }
    .form-name{
        @include fontstyle(14px, #606266, 400);
        @include userselect();
        margin: 0 8px 0 14px;
    }
    /deep/ .el-input .input-text{
        vertical-align: -5px;
    }
    .seach-set-box{
        margin-top: 12px;
        @include flex();
        @include alitem(space-between, center);
        box-sizing: border-box;
        padding-right: 16px;
        /deep/ .el-button{
            margin-right: 8px;
        }
        /deep/ .el-input .input-seach{
            vertical-align: -7px;
        }
        /deep/ .el-input.seach-input{
            width: 260px;
            height: 32px;
            margin: 0 16px;
            opacity: 1;
            border-radius: 2px;
            .el-input__inner{
                background: #F1F2F4;
            }
        }
    }
    
}
</style>